<template>
    <div class="form-group field field-checkboxlist">
        <label class="control-label">{{ question.question }} <span v-if="question.required" class="text-muted small" style="font-weight: normal">Required</span></label>
        <div class="checkboxList">
            <div class="checkbox">
                <label v-bind:for="componnentId">
                <input v-bind:id="componnentId"
                       v-bind:type="'checkbox'" 
                       v-bind:name="componnentId" 
                       v-bind:required="question.required" 
                       v-bind:value="question.options"> 
                       <span>&nbsp;{{ question.options }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormCheckboxList',
        props: {
            question: Object,
        },
        computed: {
            componnentId() {
                return 'Question' + this.$props.question.msqID;
            }
        }  
    }
</script>